import { URLQueries } from './url_query'
import {
  MASErrorTrackCityIdError,
  MASErrorTrackGeoCoordinateError,
} from '../mas_error_track'
import { storage, xenv, locate } from '@didi/webx-js'
import { isDyProgramH5 } from '../../js/env'
const getCityIdFromQueries = () => {
  if (xenv() === 'hypassenger') {
    return
  }
  if (isDyProgramH5()) {
    return URLQueries.getQuery('trip_cityid') || URLQueries.getQuery('cityid')
  } else {
    return (
      URLQueries.getQuery('city_id') ||
      URLQueries.getQuery('trip_cityid') ||
      URLQueries.getQuery('cityid') ||
      URLQueries.getQuery('cityId')
    )
  }
}
const checkCityId = cityId => {
  if (Number(cityId) >= 100000) {
    MASErrorTrackCityIdError('cityid异常', {
      cityId: cityId,
    })
  }
}
const getFromQueries = () => {
  const cityId = getCityIdFromQueries()
  // if (cityId !== undefined) {
  const lat = Number(
    URLQueries.getQuery('lat') || URLQueries.getQuery('latitude')
  )
  const lng = Number(
    URLQueries.getQuery('lng') || URLQueries.getQuery('longitude')
  )
  if ((lat && !lng) || (!lat && lng)) {
    try {
      MASErrorTrackGeoCoordinateError(lat && !lng ? '缺少 lng' : '缺少 lat', {
        url: window.location.href,
        referer: window.document.referrer,
      })
    } catch (error) {}
  }
  const _locationInfo = {
    cityId,
    lat: Number.isNaN(lat) ? 0 : lat,
    lng: Number.isNaN(lng) ? 0 : lng,
  }
  storage.locationInfo = _locationInfo
  return _locationInfo
  // }
}

/**
 * 获取定位信息，先从 URL Query 拿，拿不到走 k
 * @return {LocationInfo}
 */
export const getLocationInfo = () =>
  new Promise((resolve, reject) => {
    const resultFromQueries = getFromQueries() || {}
    const _cityidFlag =
      +resultFromQueries.cityId && +resultFromQueries.cityId !== -1
    const latAndLng = resultFromQueries.lat && resultFromQueries.lng
    // 端上资源位进入会默认拼接cityid，因此如果端上如果只有cityid，则调bridge拿经纬度
    if (xenv() === 'passenger' && _cityidFlag && !latAndLng) {
      locate()
        .then(res => {
          const { lat, lng } = res
          return resolve({
            errno: 0,
            errmsg: 'ok',
            cityId: resultFromQueries.cityId,
            lat,
            lng,
          })
        })
        .catch(() => {
          return resolve({
            errno: 0,
            errmsg: 'ok',
            cityId: resultFromQueries.cityId,
            lat: 0,
            lng: 0,
          })
        })
      return
    }
    // 如果小程序环境下，有哪个用哪个有 cityId || lat && lng，则直接返回
    // 因为如果端上都有拼cityid会导致命不中区县逻辑，小程序少量可接受
    if (_cityidFlag || latAndLng) {
      resultFromQueries.cityId && checkCityId(resultFromQueries.cityId)
      return resolve(resultFromQueries)
    }

    // 支付宝小程序下不会自动存储定位授权状态, 这里手动判断, 逻辑上和微信小程序对其
    if (xenv() === 'alimp' && !getPrivateLocate()) {
      return resolve({
        errno: 0,
        errmsg: '未获取定位授权',
        cityId: undefined,
        lat: 0,
        lng: 0,
      })
    }

    locate()
      .then(res => {
        const { lat, lng, cityId } = res
        if ((+cityId && +cityId !== -1) || (lat && lng)) {
          return resolve({
            errno: 0,
            errmsg: 'ok',
            cityId: cityId,
            lat,
            lng,
          })
        }
        return resolve({
          errno: -1,
          errmsg: res.errmsg,
          cityId: null,
          lat: 0,
          lng: 0,
        })
      })
      .catch(err => {
        return resolve({
          errno: -1,
          errmsg: err,
          cityId: null,
          lat: 0,
          lng: 0,
        })
      })
  })

// export const getLocationInfo1 = () => {
//   // TODO 考虑点1: locate的快速定位在url中cityid字段为0，返回{}
//   return locate({ useQuickOption: 'city' })
//     .then(res => {
//       const { lat, lng, cityId } = res
//       // TODO 2, 此处加+cityId && +cityId !== -1的意义？与原MASErrorTrackCityIdError有getLocationInfo判断存在差异，如何考量线上的兼容
//       if (+cityId && +cityId !== -1) {
//         if (cityId?.toString()?.length >= 6) {
//           MASErrorTrackCityIdError('cityid异常', {
//             cityId: cityId,
//           })
//         }
//         return Promise.resolve({
//           errno: 0,
//           errmsg: 'ok',
//           cityId: cityId,
//           lat,
//           lng,
//         })
//       }
//       const params = {
//         from_lat: lat || -1,
//         from_lng: lng || -1,
//       }
//       const api = 'https://common.diditaxi.com.cn/webcore/geo/reversegeotop'
//       return get(api, { params })
//         .then(data => {
//           if (data.errno === 0 && data.data) {
//             return Promise.resolve({
//               errno: 0,
//               errmsg: 'ok',
//               cityId: data.data.cityid,
//               lat,
//               lng,
//             })
//           }
//           return Promise.resolve({
//             errno: -1,
//             errmsg: data.errmsg,
//             cityId: null,
//           })
//         })
//         .catch(err => {
//           return Promise.resolve({ errno: -1, errmsg: err, cityId: null })
//         })
//     })
//     .catch(err => {
//       return Promise.resolve({ errno: -1, errmsg: err, cityId: null })
//     })
// }

const getPrivateLocate = () => {
  if (!URLQueries.private_auth_params) return true
  const privateArr = URLQueries.private_auth_params.split('-')
  const privateParams = {}
  privateArr.forEach(item => {
    const arr = item.split('_')
    if (arr[0]) {
      privateParams[arr[0]] = arr?.[1] === '1'
    }
  })
  return privateParams.locate && privateParams.miniLocate
}
